import { ReactNode } from "react";

interface ISolutionSectionWrapperProps {
  title: string;
  children?: ReactNode;
}

export const SolutionSectionWrapper = ({
  title,
  children,
}: ISolutionSectionWrapperProps) => {
  return (
    <div className="flex flex-col bg-gray-v2-100 rounded-[1.25rem]">
      <span className="px-4 py-3 text-lg font-semibold text-gray-v2-900">
        {title}
      </span>
      <div className="px-4 pb-4 grid grid-cols-2 2xl:grid-cols-3 gap-4">
        {children}
      </div>
    </div>
  );
};
